import { render, staticRenderFns } from "./WidgetGraphCard.vue?vue&type=template&id=74c13059"
import script from "./WidgetGraphCard.vue?vue&type=script&lang=js"
export * from "./WidgetGraphCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports